"use client";
import React, { useState, useEffect } from "react";
import { Grid, TextField, Select, MenuItem, FormControl } from "@mui/material";
import { getBaseUrl } from "../../utils";
import Loder from "../../Loder/Loder";
import { notificationHandler } from "../../utils/Notification";
import s from "./notificationPage.module.css";
import Custombutton from "../../Common/Custombutton";
import { sendNotification_api, getPujaListByName_api } from "../api/notification"; // Importing the API functions
import { useNavigate } from "react-router-dom";

const NotificationPage = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [redirect, setRedirect] = useState("No");
  const [redirectModel, setRedirectModel] = useState("None");
  const [redirectId, setRedirectId] = useState("");
  const [image, setImage] = useState(null);
  const [pujaList, setPujaList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
 const navigate = useNavigate()
  useEffect(() => {
    fetchPujaList();
  }, []);

  const fetchPujaList = async () => {
    setIsLoading(true);
    try {
      const response = await getPujaListByName_api();
      if (response.data.status) {
        setPujaList(response.data.data || []);
      } else {
        notificationHandler({ type: "error", msg: response.data.message });
      }
    } catch (error) {
      notificationHandler({ type: "error", msg: "Error fetching Puja list" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleRedirectChange = (e) => {
    const value = e.target.value;
    setRedirect(value);
    if (value === "Yes") {
      setRedirectModel("Puja");
      setImage(null); // Clear image if switching to Puja notification
    } else {
      setRedirectModel("None");
      setRedirectId(""); // Clear redirectId if general
    }
  };

  const handleSubmit = async () => {
    if (!title || !message) {
      notificationHandler({ type: "error", msg: "Title and message are required" });
      return;
    }
    if (redirect === "Yes" && !redirectId) {
      notificationHandler({ type: "error", msg: "Select a Puja for redirection" });
      return;
    }
    if (redirect === "No" && !image) {
      notificationHandler({ type: "error", msg: "Upload an image for general notification" });
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("message", message);
    formData.append("redirect", redirect);
    formData.append("redirectModel", redirectModel);
    if (redirect === "Yes") {
      formData.append("redirectId", redirectId);
    }
    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await sendNotification_api(formData);
      if (response.data.status) {
        notificationHandler({ type: "success", msg: response.data.message });
        // Reset form
        setTitle("");
        setMessage("");
        setRedirect("No");
        setRedirectModel("None");
        setRedirectId("");
        setImage(null);
      } else {
        notificationHandler({ type: "error", msg: response.data.message });
      }
    } catch (error) {
      notificationHandler({ type: "error", msg: "Error sending notification" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", margin: "0 auto" }}>
      <h2>Send Notification</h2>
      <div onClick={()=>navigate("/notification-history")} style={{maxWidth:"fit-content"}}>
        <Custombutton>History</Custombutton>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <label>Title</label>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <label>Message</label>
          <TextField
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            multiline
            rows={4}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <label>Redirect</label>
            <Select value={redirect} onChange={handleRedirectChange}>
              <MenuItem value="No">No</MenuItem>
              <MenuItem value="Yes">Yes</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {redirect === "Yes" && (
          <Grid item xs={6}>
            <FormControl fullWidth>
              <label>Select Puja</label>
              <Select value={redirectId} onChange={(e) => setRedirectId(e.target.value)}>
                <MenuItem value="">Choose Puja</MenuItem>
                {pujaList.map((puja) => (
                  <MenuItem key={puja._id} value={puja._id}>
                    {puja.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={6}>
          <label>Image</label>
          <div className="form-group">
            <input type="file" accept="image/*" className="form-control" onChange={handleImageChange} />
          </div>
        </Grid>
        <Grid item xs={12}>
          <div
            className="form-login-btn"
            onClick={handleSubmit}
            style={{ marginTop: "20px" }}
          >
            <Custombutton>
              Send Notification
            </Custombutton>
          </div>
        </Grid>
      </Grid>
      <Loder loading={isLoading} />
    </div>
  );
};

export default NotificationPage;